import { useEffect, useLayoutEffect, useRef } from "react";

/**
 * Cierra (o lo que corresponda) con la tecla Esc.
 *
 * Los modales activos forman una pila: Esc solo le llega al último que se
 * abrió, así un diálogo encima de otro se cierra de a uno. Si algo dentro del
 * modal ya usó el Esc (p. ej. un desplegable que se cierra) y lo marcó con
 * `preventDefault`/`stopPropagation`, el modal no reacciona.
 */
const pila: Array<{ disparar: () => void }> = [];

const onKeyDown = (event: KeyboardEvent) => {
  if (event.key !== "Escape" || event.defaultPrevented || event.isComposing) return;
  const tope = pila[pila.length - 1];
  if (!tope) return;
  event.preventDefault();
  tope.disparar();
};

export const useEscapeKey = (handler: () => void, activo = true) => {
  const handlerRef = useRef(handler);
  useLayoutEffect(() => {
    handlerRef.current = handler;
  });

  useEffect(() => {
    if (!activo) return;
    const entrada = { disparar: () => handlerRef.current() };
    pila.push(entrada);
    if (pila.length === 1) window.addEventListener("keydown", onKeyDown);
    return () => {
      const i = pila.lastIndexOf(entrada);
      if (i >= 0) pila.splice(i, 1);
      if (pila.length === 0) window.removeEventListener("keydown", onKeyDown);
    };
  }, [activo]);
};
